module.exports = {
  types: (() => [
    'categories',
    'movies',
    'scenes',
    'studios',
    'performers',
    'amateurs',
    'clips',
  ]
    .filter((entry) => {
      switch (entry) {
        default:
          return true;

        case 'scenes':
          return typeof window !== 'undefined' && !!window.swinger.config.hasScenes;

        case 'amateurs':
        case 'clips':
          return typeof window !== 'undefined' && !!window.swinger.config.hasAmateurs;
      }
    }))(),
  cardComponentName: {
    categories: 'card-category',
    movies: 'card-movie',
    scenes: 'card-scene',
    studios: 'card-studio',
    performers: 'card-performer',
    amateurs: 'card-amateur',
    clips: 'card-clip',
  },
  recommendationsApiUrl: (() => {
    if (typeof window !== 'undefined') {
      return {
        movies: window.swinger.config.apiRoutes.recommendMovies,
        scenes: window.swinger.config.apiRoutes.recommendScenes,
        studios: window.swinger.config.apiRoutes.recommendStudios,
        performers: window.swinger.config.apiRoutes.recommendPerformers,
      };
    }
    return {};
  })(),
  searchApiUrl: (() => {
    if (typeof window !== 'undefined') {
      return {
        categories: window.swinger.config.apiRoutes.searchCategories,
        movies: window.swinger.config.apiRoutes.searchMovies,
        scenes: window.swinger.config.apiRoutes.searchScenes,
        studios: window.swinger.config.apiRoutes.searchStudios,
        performers: window.swinger.config.apiRoutes.searchPerformers,
        amateurs: window.swinger.config.apiRoutes.searchAmateurs,
        clips: window.swinger.config.apiRoutes.searchClips,
      };
    }
    return {};
  })(),
};



// WEBPACK FOOTER //
// ./src/_utilities/types.js